export default __webpack_public_path__ + "static/media/image_double_100.8294403c.svg";